var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSortAsc = function SvgSortAsc(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00114 5C8.21385 5 8.41785 5.0845 8.56826 5.23491L11.7674 8.43402C12.0806 8.74723 12.0806 9.25505 11.7674 9.56826C11.4542 9.88147 10.9463 9.88147 10.6331 9.56826L8.00114 6.93626L5.36914 9.56826C5.05593 9.88147 4.54812 9.88147 4.23491 9.56826C3.9217 9.25505 3.9217 8.74723 4.23491 8.43402L7.43402 5.23491C7.58443 5.0845 7.78843 5 8.00114 5Z",
    fill: "#6D6A73"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00114 5C8.44409 5 8.80317 5.35908 8.80317 5.80203V18.5985C8.80317 19.0414 8.44409 19.4005 8.00114 19.4005C7.55819 19.4005 7.19911 19.0414 7.19911 18.5985V5.80203C7.19911 5.35908 7.55819 5 8.00114 5Z",
    fill: "#6D6A73"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3982 12.2003C10.3982 11.7573 10.7573 11.3982 11.2003 11.3982H14.3993C14.8423 11.3982 15.2013 11.7573 15.2013 12.2003C15.2013 12.6432 14.8423 13.0023 14.3993 13.0023H11.2003C10.7573 13.0023 10.3982 12.6432 10.3982 12.2003Z",
    fill: "#6D6A73"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3982 15.3994C10.3982 14.9564 10.7573 14.5973 11.2003 14.5973H16.7986C17.2416 14.5973 17.6007 14.9564 17.6007 15.3994C17.6007 15.8423 17.2416 16.2014 16.7986 16.2014H11.2003C10.7573 16.2014 10.3982 15.8423 10.3982 15.3994Z",
    fill: "#6D6A73"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3982 18.5985C10.3982 18.1555 10.7573 17.7965 11.2003 17.7965H19.198C19.6409 17.7965 20 18.1555 20 18.5985C20 19.0414 19.6409 19.4005 19.198 19.4005H11.2003C10.7573 19.4005 10.3982 19.0414 10.3982 18.5985Z",
    fill: "#6D6A73"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSortAsc);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "sort-asc.7bb0c28f895aacd46dda336446eec91d.svg";